module.exports = __webpack_public_path__ + "static/media/bindQQ1.92bbfb12.png";